<template>
  <div>
      <base-alert type="danger" dismissible :visible="error != ''">
          <span class="alert-inner--text">{{ $t(error) }}</span>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <loading-panel :visible="loading"></loading-panel>
    <div class="header pb-8 pt-4 pt-lg-5 d-flex profile-header"
        style="min-height: 100vh; background-image: url(img/theme/header-background.png); background-size: cover; background-position: center top;"
    >
      <b-container fluid class="mt-6">
        <b-row align-v="center">
          <b-col cols="6">
            <h4 class="display-4 text-dark">{{ $t('admin.meetup.pageTitle') }}</h4>
          </b-col>
          <b-col cols="6" align="right">
            <h4>
                <router-link class="display-5 text-white" to="/admin/meetup">
                    &larr;&nbsp;&nbsp;{{ $t('admin.back') }}
                </router-link>
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="12">
            <card>
              <b-row align-v="center" slot="header" >
                <b-col cols="12" md="12">
                  <b-row align-v="center">
                      <b-col cols="7">
                          <h3 class="mb-0 py-2">{{id>0? $t('admin.meetup.edittitle'):$t('admin.meetup.addtitle') }}</h3>
                      </b-col>
                      <!-- <b-col cols="5" class="text-right pr-0">
                        <b-col v-bind:style="styles.flagColStyle">
                          <el-tooltip placement="bottom" :content="$t('tooltip.language.fr')">
                            <b-link @click="onTranslate('fr')"><country-flag country='fr' size='normal' v-bind:style="lang=='fr'? styles.flagFocusStyle:styles.flagNotFocusStyle"/></b-link>
                          </el-tooltip>
                          <a href="javascript:void(0)" class="icon action-delete pl-2 pr-2" @click="exchangeLang()">
                              <i><img  src="img/icons/common/exchange-alt-solid.svg"/></i>
                          </a>
                          <el-tooltip placement="bottom" :content="$t('tooltip.language.en')">
                            <b-link @click="onTranslate('en')"><country-flag country='gb' size='normal' v-bind:style="lang=='en'? styles.flagFocusStyle:styles.flagNotFocusStyle"/></b-link>   
                          </el-tooltip>
                        </b-col>
                      </b-col>-->
                  </b-row>
                </b-col>
              </b-row>

              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(updateServiceLine)">
                  <div>
                    <b-row>
                      <b-row class="col-lg-12">
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label required">{{ $t('admin.meetup.formMeetupTitleFR') }}</label>
                            <validation-provider
                              :name="'titlefr'"
                              :rules="{ required: true, max: 100 }"
                              v-slot="a"
                            >
                            <b-form-input
                              :label="$t('admin.meetup.formMeetupTitle')"
                              :placeholder="$t('admin.meetup.formMeetupTitlePlaceholder')"
                              v-model="meetup['fr'].sll_title"
                              :state="getValidationState(a)"
                              @input="generateCalendarLink"
                              :maxlength="100"
                            />
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label required">{{ $t('admin.meetup.formMeetupTitleEN') }}</label>
                            <validation-provider
                              :name="'titleen'"
                              :rules="{ required: true, max: 100 }"
                              v-slot="abis"
                            >
                            <b-form-input
                              :label="$t('admin.meetup.formMeetupTitle')"
                              :placeholder="$t('admin.meetup.formMeetupTitlePlaceholder')"
                              v-model="meetup['en'].sll_title"
                              :state="getValidationState(abis)"
                              @input="generateCalendarLink"
                              :maxlength="100"
                            />
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label ">{{ $t('admin.meetup.formMeetupDescriptionFR') }}</label>
                            <b-form-textarea
                              rows="3"
                              :label="$t('admin.meetup.formMeetupDescriptionFR')"
                              :placeholder="$t('admin.meetup.formMeetupDescriptionFRPlaceholder')"
                              v-model="meetup['fr'].sll_description"
                              :maxlength="1024"
                            />
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label ">{{ $t('admin.meetup.formMeetupDescriptionEN') }}</label>
                            <b-form-textarea
                              rows="3"
                              :label="$t('admin.meetup.formMeetupDescriptionEN')"
                              :placeholder="$t('admin.meetup.formMeetupDescriptionENPlaceholder')"
                              v-model="meetup['en'].sll_description"
                              :maxlength="1024"
                            />
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label required">{{ $t('admin.meetup.formMeetupChairpersons') }}</label>
                            <validation-provider
                              :name="'url'"
                              :rules="{ required: true, max: 128 }"
                              v-slot="b"
                            >
                            <b-form-input
                              :label="$t('admin.meetup.formMeetupChairpersons')"
                              :placeholder="$t('admin.meetup.formMeetupChairpersonsPlaceholder')"
                              v-model="meetup.sli_speakers"
                              :state="getValidationState(b)"
                              :maxlength="128"
                            />
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label required">{{ $t('admin.meetup.formAccessLevel') }}</label>
                            <validation-provider
                              :name="'level'"
                              :rules="{ required: true }"
                               v-slot="g"
                            >
                            <b-form-select
                              :label="$t('admin.meetup.formAccessLevel')"
                              v-model="meetup.sli_accesslevel"
                              :state="getValidationState(g)"
                            >
                              <option v-for="index in nbOptionAccess" :key="index" :value="index">{{$t('sl.optionsAccess.'+index)}}</option>
                            </b-form-select>
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label required">{{ $t('admin.meetup.formMeetupType') }}</label>
                            <validation-provider
                              :name="'type'"
                              :rules="{ required: true }"
                              v-slot="c"
                            >
                            <b-form-select
                              :label="$t('admin.meetup.formMeetupType')"
                              v-model="meetup.slt_id"
                              :state="getValidationState(c)"
                            >
                              <option key="0" value="0" ></option>
                              <option v-for="index in nbSlType" :key="index" :value="index">{{$t('sl.type.'+index)}}</option>
                            </b-form-select>
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <b-row>
                              <b-col md="6">
                                <label class="form-control-label required">{{ $t('admin.meetup.formDateMeetup') }}</label>
                                <validation-provider
                                  :name="'datemeetup'"
                                  :rules="{ required: true }"
                                  v-slot="d"
                                >
                                  <date-picker :state="getValidationState(d)" :first-day-of-week="1" :lang="langDate" v-model="date" @change="generateCalendarLink" format="DD/MM/YYYY" required></date-picker>
                                </validation-provider>
                              </b-col>
                              <b-col md="6">
                                <b-row>
                                  <b-col md="6">
                                    <label class="form-control-label required">{{ $t('admin.meetup.formStartAtMeetup') }}</label>
                                    <br/>
                                    <validation-provider
                                      :name="'timestart'"
                                      :rules="{ required: true }"
                                      v-slot="e"
                                    >
                                      <vue-timepicker :state="getValidationState(e)" format="HH:mm" @change="generateCalendarLink" v-model="startAt"></vue-timepicker>
                                    </validation-provider>
                                  </b-col>
                                  <b-col md="6">
                                    <label class="form-control-label required">{{ $t('admin.meetup.formEndAtMeetup') }}</label>
                                    <br/>
                                    <validation-provider
                                      :name="'timeend'"
                                      :rules="{ required: true }"
                                      v-slot="f"
                                    >
                                    <vue-timepicker :state="getValidationState(f)" format="HH:mm" @change="generateCalendarLink" v-model="endAt"></vue-timepicker>
                                    </validation-provider>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col md="12" class="mt-3 ">
                            <label class="form-control-label required">{{ $t('admin.meetup.formTeamsLink') }}</label>
                            <validation-provider
                              :name="'teams'"
                              :rules="{ required: true, max: 1024 }"
                              v-slot="i"
                            >
                            <b-form-input
                              :label="$t('admin.meetup.formTeamsLink')"
                              :placeholder="$t('admin.meetup.formTeamsLinkPlaceholder')"
                              v-model="meetup.sli_teamslink"
                              :state="getValidationState(i)"
                              :maxlength="1024"
                            />
                            </validation-provider>
                          </b-col>
                          <!-- <b-col md="12" class="mt-3">
                            <label class="form-control-label">{{ $t('admin.meetup.formStreamLink') }}</label>
                            <b-form-input
                              :label="$t('admin.meetup.formStreamLink')"
                              :placeholder="$t('admin.meetup.formStreamLinkPlaceholder')"
                              v-model="meetup.sli_streamlink"
                            />
                          </b-col> -->

                          <!-- 2024[START] -->
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label">{{ $t('admin.meetup.formMeetupSubTitleFR') }}</label>
                            <validation-provider
                              :name="'titlefr'"
                              :rules="{ required: false }"
                              v-slot="a"
                            >
                            <div style="display: flex;">
                              <b-form-input
                                :label="$t('admin.meetup.formMeetupTitle')"
                                :placeholder="$t('admin.meetup.formStreamSubTitleFrPlaceholder')"
                                v-model="meetup['fr'].sll_vttname"
                                :state="getValidationState(a)"
                                @click="$refs.vttFrInput.click()"
                                class="as-fileinput"
                                readonly
                              />
                              <div class="m-auto" v-if="meetup['fr'].sll_vttname">
                                <b-icon @click="download('vtt', meetup['fr'].sll_vttname)" :title="$t('admin.meetup.download')" class="ml-2 cliquable" icon="cloud-download-fill" font-scale="1.2" variant="success"></b-icon>
                              </div>
                              <div class="m-auto" v-if="meetup['fr'].sll_vttname">
                                <b-icon @click="remove('vtt', 'fr')" :title="$t('admin.meetup.delete')" class="ml-2 cliquable" icon="trash2-fill" font-scale="1.2" variant="danger"></b-icon>
                              </div>
                            </div>
                            <input
                              class="d-none"
                              @change="onFileChange($event, 'fr')" type="file" ref="vttFrInput"
                            />                            
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label">{{ $t('admin.meetup.formMeetupSubTitleEN') }}</label>
                            <validation-provider
                              :name="'titleen'"
                              :rules="{ required: false }"
                              v-slot="abis"
                            >
                            <div style="display: flex;">
                              <b-form-input
                                :label="$t('admin.meetup.formMeetupTitle')"
                                :placeholder="$t('admin.meetup.formStreamSubTitleEnPlaceholder')"
                                v-model="meetup['en'].sll_vttname"
                                :state="getValidationState(abis)"
                                @click="$refs.vttEnInput.click()"
                                class="as-fileinput"
                                readonly
                              />
                              <div class="m-auto" v-if="meetup['en'].sll_vttname">
                                <b-icon @click="download('vtt', meetup['en'].sll_vttname)" :title="$t('admin.meetup.download')" class="ml-2 cliquable" icon="cloud-download-fill" font-scale="1.2" variant="success"></b-icon>
                              </div>
                              <div class="m-auto" v-if="meetup['en'].sll_vttname">
                                <b-icon @click="remove('vtt', 'en')" :title="$t('admin.meetup.delete')" class="ml-2 cliquable" icon="trash2-fill" font-scale="1.2" variant="danger"></b-icon>
                              </div>
                            </div>                            
                            <input
                              class="d-none"
                              @change="onFileChange($event, 'en')" type="file" ref="vttEnInput"
                            />                                
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label">{{ $t('admin.meetup.formMeetupSubTitlePL') }}</label>
                            <validation-provider
                              :name="'titlepl'"
                              :rules="{ required: false }"
                              v-slot="a"
                            >
                            <div style="display: flex;">
                              <b-form-input
                                :label="$t('admin.meetup.formMeetupTitle')"
                                :placeholder="$t('admin.meetup.formStreamSubTitlePlPlaceholder')"
                                v-model="meetup['pl'].sll_vttname"
                                :state="getValidationState(a)"
                                @click="$refs.vttPlInput.click()"
                                class="as-fileinput"
                                readonly
                              />
                              <div class="m-auto" v-if="meetup['pl'].sll_vttname">
                                <b-icon @click="download('vtt', meetup['pl'].sll_vttname)" :title="$t('admin.meetup.download')" class="ml-2 cliquable" icon="cloud-download-fill" font-scale="1.2" variant="success"></b-icon>
                              </div>
                              <div class="m-auto" v-if="meetup['pl'].sll_vttname">
                                <b-icon @click="remove('vtt', 'pl')" :title="$t('admin.meetup.delete')" class="ml-2 cliquable" icon="trash2-fill" font-scale="1.2" variant="danger"></b-icon>
                              </div>
                            </div>
                            <input
                              class="d-none"
                              @change="onFileChange($event, 'pl')" type="file" ref="vttPlInput"
                            />                            
                            </validation-provider>
                          </b-col>
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label">{{ $t('admin.meetup.formMeetupSubTitleES') }}</label>
                            <validation-provider
                              :name="'titlede'"
                              :rules="{ required: false }"
                              v-slot="a"
                            >
                            <div style="display: flex;">
                              <b-form-input
                                :label="$t('admin.meetup.formMeetupTitle')"
                                :placeholder="$t('admin.meetup.formStreamSubTitleEsPlaceholder')"
                                v-model="meetup['es'].sll_vttname"
                                :state="getValidationState(a)"
                                @click="$refs.vttEsInput.click()"
                                class="as-fileinput"
                                readonly
                              />
                              <div class="m-auto" v-if="meetup['es'].sll_vttname">
                                <b-icon @click="download('vtt', meetup['es'].sll_vttname)" :title="$t('admin.meetup.download')" class="ml-2 cliquable" icon="cloud-download-fill" font-scale="1.2" variant="success"></b-icon>
                              </div>
                              <div class="m-auto" v-if="meetup['es'].sll_vttname">
                                <b-icon @click="remove('vtt', 'es')" :title="$t('admin.meetup.delete')" class="ml-2 cliquable" icon="trash2-fill" font-scale="1.2" variant="danger"></b-icon>
                              </div>
                            </div>
                            <input
                              class="d-none"
                              @change="onFileChange($event, 'es')" type="file" ref="vttEsInput"
                            />                            
                            </validation-provider>
                          </b-col>                                                   
                          <b-col md="6" class="mt-3">
                            <label class="form-control-label">{{ $t('admin.meetup.videofile') }}</label>
                            <validation-provider
                              :name="'sli_video'"
                              :rules="{ required: false }"
                              v-slot="abis"
                            >
                            <div style="display: flex;">
                              <b-form-input
                                :label="$t('admin.meetup.formMeetupTitle')"
                                :placeholder="$t('admin.meetup.formStreamVideoPlaceholder')"
                                v-model="meetup.sli_videoname"
                                :state="getValidationState(abis)"
                                @click="$refs.videoInput.click()"
                                class="as-fileinput"
                                readonly
                              />
                              <div class="m-auto" v-if="meetup.sli_videoname">
                                <b-icon @click="download('video', meetup.sli_videoname)" :title="$t('admin.meetup.download')" class="ml-2 cliquable" icon="cloud-download-fill" font-scale="1.2" variant="success"></b-icon>
                              </div>
                              <div class="m-auto" v-if="meetup.sli_videoname">
                                <b-icon @click="remove('video')" :title="$t('admin.meetup.delete')" class="ml-2 cliquable" icon="trash2-fill" font-scale="1.2" variant="danger"></b-icon>
                              </div>
                            </div>                            
                            <input
                              class="d-none"
                              @change="onFileVideoChange($event)" type="file" ref="videoInput"
                            />                                
                            </validation-provider>

                            <!-- Upload progress -->
                            <b-col md="12" class="mt-2 px-0" v-if="isUploading">
                              <b-progress :value="uploadProgress" max="100" show-progress animated></b-progress>
                              <!--
                              <div class="d-flex justify-content-end">
                                <b-button size="sm" variant="danger" class="mt-2" @click="cancelUpload">{{ $t('admin.cancel') || 'Cancel' }}</b-button>
                              </div>
                              -->
                            </b-col>                            
                          </b-col>  

                          <b-col md="6" class="mt-3">
                            <label class="form-control-label">{{ $t('admin.meetup.thumbnail') }}</label>
                            <validation-provider
                              :name="'sli_thumbnailname'"
                              :rules="{ required: false }"
                              v-slot="abis"
                            >
                            <div style="display: flex;">
                              <b-form-input
                                :label="$t('admin.meetup.formMeetupTitle')"
                                :placeholder="$t('admin.meetup.formthumbnailPlaceholder')"
                                v-model="meetup.sli_thumbnailname"
                                :state="getValidationState(abis)"
                                @click="$refs.thumbnailInput.click()"
                                class="as-fileinput"
                                readonly
                              />
                              <div class="m-auto" v-if="meetup.sli_thumbnailname">
                                <b-icon @click="download('thumbnail', meetup.sli_thumbnailname)" :title="$t('admin.meetup.download')" class="ml-2 cliquable" icon="cloud-download-fill" font-scale="1.2" variant="success"></b-icon>
                              </div>
                              <div class="m-auto" v-if="meetup.sli_thumbnailname">
                                <b-icon @click="remove('thumbnail')" :title="$t('admin.meetup.delete')" class="ml-2 cliquable" icon="trash2-fill" font-scale="1.2" variant="danger"></b-icon>
                              </div>
                            </div>                            
                            <input
                              class="d-none"
                              @change="onThumbnailChange($event)" type="file" ref="thumbnailInput"
                            />                                
                            </validation-provider>
                          </b-col>                                                                        
                          <!-- 2024[END] -->

                          <b-col md="12" class="mt-3 d-none">
                            <label class="form-control-label required">{{ $t('admin.meetup.formCalendarLink') }}</label>
                            <validation-provider
                              :name="'calendar'"
                              :rules="{ required: true }"
                               v-slot="j"
                            >
                            <b-form-input
                              :label="$t('admin.meetup.formCalendarLink')"
                              :placeholder="$t('admin.meetup.formCalendarLinkPlaceholder')"
                              v-model="meetup.sli_calendarlink"
                              :state="getValidationState(j)"
                              readonly
                            />
                            </validation-provider>
                          </b-col>
                      </b-row>
                    </b-row>
                  </div>

                  <div align="center" class="pt-3 btn-save-meetup">
                    <button type="submit" class="btn btn-success">{{ $t('admin.carousel.saveandback') }}</button>
                  </div>
                </b-form>
              </validation-observer>
            </card>
          </b-col>
        </b-row>

        <div>
          <b-modal class="modal-confirm" size="sm" centered v-model="confirmShow" button-size="sm" hide-footer hide-header>
            <!-- Titre du modal -->
            <h3 class="text-center text-danger">{{ $t('generic.warning-title') }}</h3>  

            <span>{{ $t('generic.warning-delete-need-submit') }}</span>  
            <b-button-group class="d-flex justify-content-center">
              <b-button class="mt-3" style="max-width: 100px;" variant="primary" @click="confirmShow = false">{{ $t('ok') }}</b-button> 
            </b-button-group>
          </b-modal>
        </div>          
      </b-container>
    </div>  
  </div>
</template>
<script>
  import Vue from "vue";
  import axios from 'axios';
  import { mapActions } from "vuex";
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/en';
  import 'vue2-datepicker/locale/fr';
  import meetups from '../../../../datas/meetups';
  import { convertFileToBase64 } from '@/util/tools';
  import { BIcon } from 'bootstrap-vue';
  import { uploadFileInChunks } from '@/util/chunkUpload';
  
  export default {
    props: {

    },
    components:{
      VueTimepicker,
      DatePicker,
      BIcon
    },
    data() {
      console.log(Vue.i18n.locale());
      return {
        id: null,
        lang: Vue.i18n.locale(),
        nbOptionAccess:3,
        nbSlType:[1, 2, 4],
        meetups,
        // formValidLang: {
        //   en: false,
        //   fr: false
        // },
        formValid:false,
        langDate:Vue.i18n.locale(),
        date: '',
        startAt: null,
        endAt: null,
        sli_video: null,
        meetup: {
          slt_id: 0,
          sli_startat: '',
          sli_endat: '',
          sli_speakers: '',
          sli_accesslevel: 1,
          sli_teamslink: '',
          sli_streamlink: '',
          sli_calendarlink: '',
          sli_videoname: null,
          fr: {
            sll_title: '',
            sll_description: '',
            sll_vttname: '',
            sll_vtt: ''            
          },
          en: {
            sll_title: '',
            sll_description: '',
            sll_vttname: '',
            sll_vtt: '' 
          },
          pl: {
            sll_title: '',
            sll_description: '',            
            sll_vttname: '',
            sll_vtt: ''
          },
          es: {
            sll_title: '',
            sll_description: '',            
            sll_vttname: '',
            sll_vtt: ''
          }
        },
        styles:{
            flagNotFocusStyle:{
              borderRadius:'10px',
              boxShadow: '0 5px 2px -2px #144f56',
              opacity:'0.5'
            },
            flagFocusStyle:{
              borderRadius:'10px',
              boxShadow: '0 4px 2px -2px #144f56',
              transform: 'scale(0.6)'
            },
            flagColStyle:{
              //backgroundColor:'#e6f8e1',
              width:'fit-content',
              float:'right',
              borderRadius:'2px'
            }

          },
        error: '',
        loading: false,
        // Upload state
        isUploading: false,
        uploadProgress: 0,
        cancelSource: null,
        confirmShow: false,
      };
    },
    mounted() {
      this.id = this.$route.params.id;
      if(this.id > 0) {
        this.getServiceLine(this.id)
      }else{
        this.startAt = '12:30';
        this.endAt = '13:30';
      }
    },
    methods: {
      ...mapActions(["CreateServiceLine", "UpdateServiceLine", "GetServiceLine", "DownloadFile"]),
      // getValidationStateLang({ dirty, validated, valid = null }) {
      //   let isValid = dirty || validated ? valid : null;
      //   this.formValidLang[this.lang] = isValid;
      //   return isValid;
      // },
      getValidationState({ dirty, validated, valid = null }) {
        let isValid = dirty || validated ? valid : null;
        this.formValid = isValid;
        return isValid;
      },  
      validationWholeForm(){
        let validation = true;
        if(this.meetup.slt_id<1){
          validation = false;
        }
        if(this.meetup.sli_startat===''){
          validation = false;
        }
        if(this.meetup.sli_endat===''){
          validation = false;
        }
        if(this.meetup.sli_speakers===''){
          validation = false;
        }
        if(this.meetup.sli_accesslevel<1){
          validation = false;
        }
        if(this.meetup.sli_teamslink===''){
          validation = false;
        }
        if(this.meetup.sli_calendarlink===''){
          validation = false;
        }
        if(this.meetup.fr.sll_title===''){
          validation = false;
        }
        if(this.meetup.en.sll_title===''){
          validation = false;
        }
        return validation ;
      },
      validationTime(){
        if(new Date (this.meetup.sli_startat) > new Date (this.meetup.sli_endat)){
            return false;
        }
        return true;
      },
      async updateServiceLine() {
        if (this.id > 0) {
          let allFieldFull = this.validationWholeForm();
          if(!allFieldFull){
            this.error = "alert.fillallfieldform";
            return
          }
          this.loading = true;
          //console.log("body: ", this.meetup);
          const CHUNK_THRESHOLD = 50 * 1024 * 1024; // 50MB
          const useChunk = this.sli_video && this.sli_video.size && this.sli_video.size > CHUNK_THRESHOLD;

          const formData = new FormData();
          // N'ajouter la vidéo dans le formData que si on n'utilise pas les chunks
          if (!useChunk) {
            formData.append('sli_video', this.sli_video);
            formData.append('sli_videoname', this.meetup.sli_videoname);
          } else {
            // Indiquer explicitement au backend que la vidéo sera gérée par chunking
            formData.append('sli_videoname', this.meetup.sli_videoname || `video_${this.id}.mp4`);
          }

          if (this.meetup.sli_thumbnailname != null) {
              //formData.append('sli_thumbnailname', `thumb_${this.meetup.sli_id}.png`);
              formData.append('sli_thumbnailname', this.meetup.sli_thumbnailname);
              formData.append('sli_thumbnail', this.meetup.sli_thumbnail);
          }          

          // Ajout des champs simples
          formData.append('slt_id', this.meetup.slt_id);
          formData.append('sli_startat', this.meetup.sli_startat);
          formData.append('sli_endat', this.meetup.sli_endat);
          formData.append('sli_speakers', this.meetup.sli_speakers);
          formData.append('sli_accesslevel', this.meetup.sli_accesslevel);
          formData.append('sli_teamslink', this.meetup.sli_teamslink);
          formData.append('sli_streamlink', this.meetup.sli_streamlink);
          formData.append('sli_calendarlink', this.meetup.sli_calendarlink);

          // Ajout des champs pour la langue française
          formData.append('fr[sll_title]', this.meetup.fr.sll_title);
          formData.append('fr[sll_description]', this.meetup.fr.sll_description);
          if (this.meetup.fr.sll_vtt != null) {
              formData.append('fr[sll_vttname]', `${this.meetup.sli_id}_fr.vtt`);
              formData.append('fr[sll_vtt]', this.meetup.fr.sll_vtt);
          }

          // Ajout des champs pour la langue anglaise
          formData.append('en[sll_title]', this.meetup.en.sll_title);
          formData.append('en[sll_description]', this.meetup.en.sll_description);
          if (this.meetup.en.sll_vtt != null) {
              formData.append('en[sll_vttname]', `${this.meetup.sli_id}_en.vtt`);
              formData.append('en[sll_vtt]', this.meetup.en.sll_vtt);
          }

          formData.append('pl[sll_title]', this.meetup.en.sll_title);
          formData.append('pl[sll_description]', this.meetup.en.sll_description);          
          if (this.meetup.pl.sll_vtt != null) {
              formData.append('pl[sll_vttname]', `${this.meetup.sli_id}_pl.vtt`);
              formData.append('pl[sll_vtt]', this.meetup.pl.sll_vtt);
          }

          formData.append('es[sll_title]', this.meetup.en.sll_title);
          formData.append('es[sll_description]', this.meetup.en.sll_description);          
          if (this.meetup.es.sll_vtt != null) {
              formData.append('es[sll_vttname]', `${this.meetup.sli_id}_es.vtt`);
              formData.append('es[sll_vtt]', this.meetup.es.sll_vtt);
          }

          // Préparer la config axios pour le suivi du progress et annulation
          this.isUploading = true;
          this.uploadProgress = 0;
          this.cancelSource = axios.CancelToken.source();
          const config = {
            cancelToken: this.cancelSource.token,
            onUploadProgress: (progressEvent) => {
              if (progressEvent && progressEvent.total) {
                this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            }
          };

          try {
            // 1) Mettre à jour les métadonnées (sans vidéo si useChunk)
            await this.UpdateServiceLine({id:this.id, formData: formData, config});

            // 2) Si chunking nécessaire, envoyer les chunks et finaliser
            if (useChunk) {
              await uploadFileInChunks({
                axios,
                file: this.sli_video,
                apiBase: `${process.env.VUE_APP_APIURL}upload`,
                onProgress: (p) => { this.uploadProgress = p; },
                sli_id: this.id,
                cancelToken: this.cancelSource.token
              });
            }

            this.$router.push({ path: '/admin/meetup' })
          } catch (e) {
            // Afficher le message d'erreur serveur s'il existe
            this.error = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : $t('UPLOAD_FAILED');
          } finally {
            this.isUploading = false;
            this.loading = false;
            this.cancelSource = null;
          }
        }else{
          this.error = '';
          let hourOk=this.validationTime();
          if(!hourOk){
             this.error = "alert.startandendtime";
             return
          }
          let allFieldFull=this.validationWholeForm();
          if(!allFieldFull){
            this.error = "alert.fillallfieldform";
            return
          }
          // if(!this.formValidLang.en || !this.formValidLang.fr){
          //   this.error = "alert.fillfrandenform";
          //   return
          // };
          this.loading = true;
          //console.log("body: ", this.meetup);
          const CHUNK_THRESHOLD = 50 * 1024 * 1024; // 50MB
          const useChunk = this.sli_video && this.sli_video.size && this.sli_video.size > CHUNK_THRESHOLD;
          
          const formData = new FormData();
          // N'ajouter la vidéo dans le formData que si on n'utilise pas les chunks
          if (!useChunk) {
            formData.append('sli_video', this.sli_video);
          }

          if (this.meetup.sli_thumbnail != null) {
              //formData.append('sli_thumbnailname', `${this.meetup.sli_thumbnailname}.png`);
              formData.append('sli_thumbnailname', `${this.meetup.sli_thumbnailname}.png`);
              formData.append('sli_thumbnail', this.meetup.sli_thumbnail);
          }          

          // Ajout des champs simples
          formData.append('slt_id', this.meetup.slt_id);
          formData.append('sli_startat', this.meetup.sli_startat);
          formData.append('sli_endat', this.meetup.sli_endat);
          formData.append('sli_speakers', this.meetup.sli_speakers);
          formData.append('sli_accesslevel', this.meetup.sli_accesslevel);
          formData.append('sli_teamslink', this.meetup.sli_teamslink);
          formData.append('sli_streamlink', this.meetup.sli_streamlink);
          formData.append('sli_calendarlink', this.meetup.sli_calendarlink);

          // Ajout des champs pour la langue française
          formData.append('fr[sll_title]', this.meetup.fr.sll_title);
          formData.append('fr[sll_description]', this.meetup.fr.sll_description);

          if (this.meetup.fr.sll_vtt != null) {
              formData.append('fr[sll_vttname]', `${this.meetup.sli_id}_fr.vtt`);
              formData.append('fr[sll_vtt]', this.meetup.fr.sll_vtt);
          }

          // Ajout des champs pour la langue anglaise
          formData.append('en[sll_title]', this.meetup.en.sll_title);
          formData.append('en[sll_description]', this.meetup.en.sll_description);
          if (this.meetup.en.sll_vtt != null) {
              formData.append('en[sll_vttname]', `${this.meetup.sli_id}_en.vtt`);
              formData.append('en[sll_vtt]', this.meetup.en.sll_vtt);
          }

          formData.append('pl[sll_title]', this.meetup.en.sll_title);
          formData.append('pl[sll_description]', this.meetup.en.sll_description);          
          if (this.meetup.pl.sll_vtt != null) {
              formData.append('pl[sll_vttname]', `${this.meetup.sli_id}_pl.vtt`);
              formData.append('pl[sll_vtt]', this.meetup.pl.sll_vtt);
          }

          formData.append('es[sll_title]', this.meetup.en.sll_title);
          formData.append('es[sll_description]', this.meetup.en.sll_description);          
          if (this.meetup.es.sll_vtt != null) {
              formData.append('es[sll_vttname]', `${this.meetup.sli_id}_es.vtt`);
              formData.append('es[sll_vtt]', this.meetup.es.sll_vtt);
          }          

          // Préparer la config axios pour le suivi du progress et annulation
          this.isUploading = true;
          this.uploadProgress = 0;
          this.cancelSource = axios.CancelToken.source();
          const config = {
            cancelToken: this.cancelSource.token,
            onUploadProgress: (progressEvent) => {
              if (progressEvent && progressEvent.total) {
                this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            }
          };

          try {
            // 1) Créer la SL d'abord (sans vidéo si useChunk) pour récupérer l'id
            const createRes = await this.CreateServiceLine({ body: formData, config });
            const newId = createRes && createRes.sli_id ? createRes.sli_id : null;

            if (useChunk && newId) {
              await uploadFileInChunks({
                axios,
                file: this.sli_video,
                apiBase: `${process.env.VUE_APP_APIURL}upload`,
                onProgress: (p) => { this.uploadProgress = p; },
                sli_id: newId,
                cancelToken: this.cancelSource.token
              });
            }

            this.$router.push({ path: '/admin/meetup' })
          } catch (e) {
            this.error = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : $t('UPLOAD_FAILED');
            console.log(e);
          } finally {
            this.isUploading = false;
            this.loading = false;
            this.cancelSource = null;
          }
        }
      },
      cancelUpload() {
        if (this.cancelSource) {
          this.cancelSource.cancel('Upload cancelled by user');
        }
      },
      async getServiceLine(id) {
        this.GetServiceLine(id)
          .then(
            data => {
              var sllFr = data.servicelinelangs.find(x => x.lan_code == 'fr');
              var sllEn = data.servicelinelangs.find(x => x.lan_code == 'en');
              var sllPl = data.servicelinelangs.find(x => x.lan_code == 'pl');
              var sllDe = data.servicelinelangs.find(x => x.lan_code == 'es');
              this.meetup = {
                slt_id: data.slt_id,
                sli_startat: data.sli_startat,
                sli_endat: data.sli_endat,
                sli_speakers: data.sli_speakers,
                sli_accesslevel: data.sli_accesslevel,
                sli_teamslink: data.sli_teamslink,
                sli_streamlink: data.sli_streamlink,
                sli_calendarlink: data.sli_calendarlink,
                sli_videoname: data.sli_video,
                sli_thumbnailname: data.sli_thumbnail != null?`thumb_${data.sli_id}.png` : null,
                fr: {
                  sll_title: sllFr.sll_title,
                  sll_description: sllFr.sll_description,
                  sll_vttname: sllFr && sllFr.vtt != null?`${data.sli_id}_${'fr'}.vtt` : null,
                  sll_vtt: sllFr? sllFr.vtt : null
                },
                en: {
                  sll_title: sllEn.sll_title,
                  sll_description: sllEn.sll_description,
                  sll_vttname: sllEn && sllEn.vtt != null?`${data.sli_id}_${'en'}.vtt` : null,
                  sll_vtt: sllEn? sllEn.vtt : null
                },
                pl: {
                  sll_title: sllEn.sll_title,
                  sll_description: sllEn.sll_description,                  
                  sll_vttname: sllPl && sllPl.vtt != null?`${data.sli_id}_${'pl'}.vtt` : null,
                  sll_vtt: sllPl? sllPl.vtt : null
                },
                es: {
                  sll_title: sllEn.sll_title,
                  sll_description: sllEn.sll_description,                  
                  sll_vttname: sllDe && sllDe.vtt != null?`${data.sli_id}_${'es'}.vtt` : null,
                  sll_vtt: sllDe? sllDe.vtt : null
                }
              };
              this.date=this.convertToDate(data.sli_startat);
              this.startAt=this.convertToHour(data.sli_startat);
              this.endAt=this.convertToHour(data.sli_endat);
            }
        )
        .catch(
          error => console.log(error)
        )
      },
      onTranslate(language){
        this.lang=language;
      },
      exchangeLang() {
        this.lang == 'fr'?this.lang = 'en':this.lang = 'fr';
        this.error = '';
      },
      sLSetStartAt(){
        if(this.startAt!='' && this.date!=null && this.date!=''){
          if(this.startAt.includes("H")|| this.startAt.includes("m")){
            return false;
          }
          let sDate=this.convertToStringDate(this.date);
          this.meetup.sli_startat=sDate+" "+this.startAt+":00.000";
          return true;
        }
        else{
          this.meetup.sli_startat="";
          return false;
        }
      },
      sLSetEndAt(){
        if(this.endAt!='' && this.date!=null && this.date!=''){
          if(this.endAt.includes("H")|| this.endAt.includes("m")){
            return false;
          }
          let sDate=this.convertToStringDate(this.date);
          this.meetup.sli_endat=sDate+" "+this.endAt+":00.000";
          return true;
        }
        else{
          this.meetup.sli_endat="";
          return false;
        }
        
      },
      convertToDate(stringDate){
        //date month with JS starts from 0 so, month=month-1
        const sYear=stringDate.toString().substring(0, 4);
        const sMonth=stringDate.toString().substring(5,7);
        const sDay=stringDate.toString().substring(8,10);
        return new Date(sYear, sMonth-1, sDay);
      },
      convertToHour(stringDate){
        const sHour=stringDate.toString().substring(11,13);
        const sMinute=stringDate.toString().substring(14,16);
        return sHour+":"+sMinute;

      },
      convertToStringDate(rDate){
          let sDate='';
          if(rDate!=null){
              sDate=rDate.getFullYear()+'-'+(rDate.getMonth()+1)+'-'+rDate.getDate();
          }
          return sDate;
      },
      getGMTDateTime(date){
        var d = new Date(date);
        var timeOffsetInMS= d.getTimezoneOffset() * 60000;
        d.setTime(d.getTime() + timeOffsetInMS);
        return d
      },
      dateToLinkFormat(date){
        let response=date.getFullYear();
        if(date.getMonth()<10){
          response+="-0"+(date.getMonth()+1);
        }
        else{
           response+="-"+(date.getMonth()+1);
        }
        if(date.getDate()<10){
          response+="-0"+date.getDate()+"T";
        }
        else{
           response+="-"+date.getDate()+"T";
        }
        if(date.getHours()<10){
          response+="0"+date.getHours();
        }
        else{
           response+=date.getHours();
        }
        //Minutes
        if(date.getMinutes()<10){
          response+=":0"+date.getMinutes();
        }
        else{
           response+=":"+date.getMinutes();
        }
        //Seconds
        if(date.getSeconds()<10){
          response+=":0"+date.getSeconds();
        }
        else{
           response+=":"+date.getSeconds();
        }
        response+="Z";
        return response;
    
      },
      generateCalendarLink(){
        let start=this.sLSetStartAt();
        let end=this.sLSetEndAt();
        if(start ===true && end===true && this.meetup.fr.sll_title!=""){
          let subject=this.meetup.fr.sll_title.replace(" ", "%20");
          let startTime=this.dateToLinkFormat(this.getGMTDateTime(this.meetup.sli_startat));
          let endTime=this.dateToLinkFormat(this.getGMTDateTime(this.meetup.sli_endat));
          let fullLink="https://teams.microsoft.com/l/meeting/new?subject="+subject+"&startTime="+startTime+"&endTime="+endTime+"&content=%3Cdiv%3ERetrouvez%20nous%20sur%20le%20portail%20%3Ca%20href%3D%27https%3A%2F%2Fgroupeastek365.sharepoint.com%2FDPO%2FServiceLines%2FSitePages%2FAccueil.aspx%27%20title%3D%27https%3A%2F%2Fgroupeastek365.sharepoint.com%2Fdpo%2Fservicelines%2Fsitepages%2Faccueil.aspx%27%20target%3D%27_blank%27%20rel%3D%27noreferrer%20noopener%27%3EService%20Lines%3C%2Fa%3E%26nbsp%3B!%3C%2Fdiv%3E";
          this.meetup.sli_calendarlink=fullLink;
        }
        else{
          this.meetup.sli_calendarlink="";
        }
      },
      onFileChange(e, lang) {
        const file = e.target.files[0];
        convertFileToBase64(file)
          .then(base64 =>
            {
              this.meetup[lang].sll_vtt = base64;
              this.meetup[lang].sll_vttname = file != null? file.name : null
            }
          );     
      },
      onFileVideoChange(e) {
        const file = e.target.files[0];
        this.sli_video = file;
        this.meetup.sli_videoname = file != null ? file.name : null;
      },
      onThumbnailChange(e) {
        const file = e.target.files[0];
        convertFileToBase64(file)
        .then(base64 =>
            {
              this.meetup.sli_thumbnail = base64;
              this.meetup.sli_thumbnailname = file != null? file.name : null
            } 
          );
      },
      download(type, filename) {
        try {
          this.DownloadFile({ type, filename })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              const fileName = response.config.url.split('/').pop();
              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();
            })
        } catch (error) {
          console.error('Error downloading file:', error);
        }        
      },
      remove(type, lang = null) {
        this.confirmShow = true;
        switch (type) {
          case 'vtt':
              this.meetup[lang].sll_vtt = null;
              this.meetup[lang].sll_vttname = null;                        
            break;

          case 'video':
              this.sli_video = null;
              this.meetup.sli_videoname = null;
            break;

          case 'thumbnail':
              this.meetup.sli_thumbnail = null;
              this.meetup.sli_thumbnailname = null            
            break;

          default:
            break;
        }
      }
    }
  };
</script>
